<template>
  <div class="user-recharge">
    <h1>用户充值</h1>
    <div class="user-options clearfix">
      <el-select style="width: 150px" v-model="curChannel.selectValue" placeholder="">
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select style="width: 180px" v-model="curPayType.selectValue" placeholder="">
        <el-option label="所有支付模式" value="-1"></el-option>
        <el-option label="google支付" value="0"></el-option>
        <el-option label="PayTm支付" value="2"></el-option>
        <el-option label="茄子支付" value="125"></el-option>
        <el-option label="ios支付" value="10"></el-option>
        <el-option label="华为支付" value="11"></el-option>
        <el-option label="tap支付" value="120"></el-option>
        <el-option label="中台支付" value="14"></el-option>
      </el-select>
      <el-select filterable style="width: 160px" v-model="country" placeholder="">
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <DatePicker @datePickedChange="datePickedChange"></DatePicker>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <div class="display-type">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="表格" name="table" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="柱状图" name="bar" class="bar-container">
          <div v-loading="loading">
            <CustomBar :options="barOptions1" class="bar"></CustomBar>
            <CustomBar :options="barOptions2" class="bar"></CustomBar>
            <CustomBar :options="barOptions3" class="bar"></CustomBar>
            <CustomBar :options="barOptions4" class="bar"></CustomBar>
            <CustomBar :options="barOptions5" class="bar"></CustomBar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="折线图" name="line">
          <div v-loading="loading">
            <CustomLine :options="lineOptions"></CustomLine>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane label="饼状图" name="pie">饼图</el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomTable from "@/components/CustomTable";
import CustomBar from "@/components/CustomBar";
import CustomLine from "@/components/CustomLine";
import DatePicker from "@/components/DatePicker";
import { getCountry } from "@/utils/normalApi.js";
import download from "@/utils/download.js";

export default {
  components: {
    CustomTable,
    CustomBar,
    CustomLine,
    DatePicker,
  },
  data() {
    return {
      country: "total",
      countryList: [],
      curChannel: {
        selectValue: "total",
        content: "",
      },
      curPayType: {
        selectValue: "-1",
        content: "",
      },
      channels: this.$store.state.channels,
      tableOptions: {
        defaultSort: {
          prop: "date",
          order: "descending",
        },
        theader: [
          {
            name: "date",
            label: "日期",
            sortable: true,
            fixed: true,
            width: "100px",
          },
          {
            name: "userCount",
            label: "充值总人数",
            sortable: true,
            fix: true,
            width: "160px",
          },
          {
            name: "payTimes",
            label: "充值总次数",
            sortable: true,
            fix: true,
            width: "160px",
          },
          {
            name: "payValue",
            label: "充值总金额",
            sortable: true,
            fix: true,
            width: "220px",
          },
          {
            name: "onlineGolds",
            label: "线上充值金币总数",
            sortable: true,
            fix: true,
            width: "220px",
          },
          {
            name: "offlineGolds",
            label: "线下充值金币总数",
            sortable: true,
            fix: true,
            width: "220px",
          },
          {
            name: "newUserCount",
            label: "充值新用户",
            sortable: true,
            fix: true,
            width: "",
          },
          {
            name: "newPayTimes",
            label: "新用户充值次数",
            sortable: true,
            fix: true,
            width: "",
          },
          {
            name: "newGolds",
            label: "新用户充值金额",
            sortable: true,
            fix: true,
            width: "140px",
          },
        ],
      },
      barOptions1: {
        title: "充值人数",
        legend: ["充值总人数", "充值新用户"],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: "true",
          data: [],
        },
        yAxis: {
          name: "人数",
          type: "value",
        },
        series: [
          {
            name: "充值总人数",
            type: "bar",
            data: [],
          },
          {
            name: "充值新用户",
            type: "bar",
            data: [],
          },
        ],
      },
      barOptions2: {
        title: "充值总次数",
        legend: ["充值总次数", "新用户充值次数"],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: "true",
          data: [],
        },
        yAxis: {
          name: "次数",
          type: "value",
        },
        series: [
          {
            name: "充值总次数",
            type: "bar",
            data: [],
          },
          {
            name: "新用户充值次数",
            type: "bar",
            data: [],
          },
        ],
      },
      barOptions3: {
        title: "金币充值",
        legend: ["线上充值金币总额", "线下充值金币总额"],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: "true",
          data: [],
        },
        yAxis: {
          name: "数量",
          type: "value",
        },
        series: [
          {
            name: "线上充值金币总额",
            type: "bar",
            data: [],
          },
          {
            name: "线下充值金币总额",
            type: "bar",
            data: [],
          },
        ],
      },
      barOptions4: {
        title: "新用户充值金额",
        legend: ["新用户充值金额"],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: "true",
          data: [],
        },
        yAxis: {
          name: "数量",
          type: "value",
        },
        series: [
          {
            name: "新用户充值金额",
            type: "bar",
            data: [],
          },
        ],
      },
      barOptions5: {
        title: "充值发起与成功数",
        legend: ["发起次数", "成功次数"],
        xAxis: {
          name: "日期",
          type: "category",
          data: [],
        },
        yAxis: {
          name: "次数",
          type: "value",
        },
        series: [
          {
            name: "发起次数",
            type: "line",
            data: [],
          },
          {
            name: "成功次数",
            type: "line",
            data: [],
          },
        ],
      },
      lineOptions: {
        title: "用户充值",
        legend: [
          "充值总人数",
          "充值总次数",
          "线上充值金币总额",
          "线下充值金币总额",
          "充值新用户",
          "新用户充值次数",
          "新用户充值金额",
        ],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: "数量",
          type: "value",
        },
        series: [
          {
            name: "充值总人数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "充值总次数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "线上充值金币总额",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "线下充值金币总额",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "充值新用户",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新用户充值次数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新用户充值金额",
            type: "line",
            smooth: true,
            data: [],
          },
        ],
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore,
      ],
      activeName: "bar",
      tableList: [],
      loading: true,
    };
  },
  beforeCreate() {},
  async created() {
    this.getList();
    const res = await getCountry();
    if (res !== null) {
      this.countryList = res.countryList;
    }
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username;
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    token() {
      return this.$store.getters.token;
    },
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date;
    },
    //获取视频通话数据
    getList() {
      this.loading = true;
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.pay,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          payType: this.curPayType.selectValue,
          country: this.country,
        },
      })
        .then(
          (res) => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data);
              this.lineOptionBuild(res.data.data);
              this.barOptionsBuild(res.data.data);
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data;
      //
      // for (let item in data){
      // 	if(data.hasOwnProperty(item)){
      // 		this.tableList.push({
      // 			date: item,
      // 			pay_count_user: data[item].pay_count_user,
      // 			pay_count_times: data[item].pay_count_times,
      // 			pay_total_online: data[item].pay_total_online,
      // 			pay_total_offline: data[item].pay_total_offline,
      // 			pay_count_user_new: data[item].pay_count_user_new,
      // 			pay_count_times_new: data[item].pay_count_times_new,
      // 			pay_total_new: data[item].pay_total_new
      // 		})
      // 	}
      // }
    },
    //柱状图配置
    barOptionsBuild(data) {
      this.barOptions1.xAxis.data = [];
      this.barOptions2.xAxis.data = [];
      this.barOptions3.xAxis.data = [];
      this.barOptions4.xAxis.data = [];
      this.barOptions5.xAxis.data = [];
      for (let i = 0; i < this.barOptions1.series.length; i++) {
        this.barOptions1.series[i].data = [];
      }
      for (let i = 0; i < this.barOptions2.series.length; i++) {
        this.barOptions2.series[i].data = [];
      }
      for (let i = 0; i < this.barOptions3.series.length; i++) {
        this.barOptions3.series[i].data = [];
      }
      for (let i = 0; i < this.barOptions4.series.length; i++) {
        this.barOptions4.series[i].data = [];
      }
      for (let i = 0; i < this.barOptions5.series.length; i++) {
        this.barOptions5.series[i].data = [];
      }
      let item;
      for (let j in data) {
        item = data[j];
        this.barOptions1.xAxis.data.push(item.date);
        this.barOptions2.xAxis.data.push(item.date);
        this.barOptions3.xAxis.data.push(item.date);
        this.barOptions4.xAxis.data.push(item.date);
        this.barOptions5.xAxis.data.push(item.date);
        this.barOptions1.series[0].data.push(item.userCount);
        this.barOptions1.series[1].data.push(item.newUserCount);
        this.barOptions2.series[0].data.push(item.payTimes);
        this.barOptions2.series[1].data.push(item.newPayTimes);
        this.barOptions3.series[0].data.push(item.onlineGolds);
        this.barOptions3.series[1].data.push(item.offlineGolds);
        this.barOptions4.series[0].data.push(item.newGolds);
        this.barOptions5.series[0].data.push(item.reqPayTimes);
        this.barOptions5.series[1].data.push(item.payTimes);
      }
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = [];
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = [];
      }
      let item;
      for (let j in data) {
        item = data[j];
        this.lineOptions.xAxis.data.push(item.date);
        this.lineOptions.series[0].data.push(item.userCount);
        this.lineOptions.series[1].data.push(item.payTimes);
        this.lineOptions.series[2].data.push(item.onlineGolds);
        this.lineOptions.series[3].data.push(item.offlineGolds);
        this.lineOptions.series[4].data.push(item.newUserCount);
        this.lineOptions.series[5].data.push(item.newPayTimes);
        this.lineOptions.series[6].data.push(item.newGolds);
      }
    },
    handleTabClick() {
      // if(tab.name === 'line') {
      // 	this.lineOptionBuild();
      // }
    },
    doInquery() {
      this.getList();
    },
    // 下载
    async dwnDayChatDetai() {
      const res = await this.$axios({
        method: "GET",
        url: this.$store.getters.path.download_pay_goods,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          payType: this.curPayType.selectValue,
          country: this.country,
        },
      });

      this.$message.success("开始下载");
      download(res.data, "用户充值" + this.datePicked[1]);
    },
  },
};
</script>

<style lang="stylus" scoped>
   @import "../../assets/stylus/variable.styl"
.user-recharge
	margin-left 20px
	margin-top 20px
	h1
		font-size 28px
		font-weight bold
	.user-options
		margin-top 40px
		button
			margin-left 30px
	.display-type
		margin-top 20px
		.bar-container
			display flex
			justify-content flex-start
			flex-wrap wrap
			.bar
				margin-left 10px
				display inline-block
				width 450px
				height 300px
</style>
